import { ConfigurableColumns } from '@/components/ConfigurableColumns';
import { CopiableIdDataGridField } from '@/components/CopiableIdField';
import { GenericDateFunctionField } from '@/components/GenericDateFunctionField';
import { DateField } from 'react-admin';

export const patientsColumns: ConfigurableColumns[] = [
  {
    label: 'Connection Id',
    source: 'id',
    GridComponent: CopiableIdDataGridField,
    sortable: true,
    gridComponentProps: {
      copyLink: true,
      targetNavigationResource: 'therapistPatients',
      formatFilter: (id: any) => ({ $oid: id }),
    },
    exportFn: (doc: any) => doc.id,
  },
  {
    label: 'Created At',
    source: 'createdAt',
    GridComponent: DateField,
    sortable: true,
    exportFn: (doc: any) => doc.createdAt?.toISOString(),
  },
  {
    label: 'Therapist Id',
    source: 'therapistId',
    GridComponent: CopiableIdDataGridField,
    gridComponentProps: {
      targetNavigationResource: 'therapists',
      filter: ['therapistId'],
      targetNavigationFilters: {
        isHiddenTestAccount: 'visible',
      },
    },
    exportFn: (doc: any) => doc.therapistId,
  },
  {
    label: 'Therapist Email',
    source: 'therapistEmail',
    exportFn: (doc: any) => doc.therapistEmail,
  },
  {
    label: 'Therapist Title',
    source: 'therapistTitle',
    exportFn: (doc: any) => doc.therapistTitle,
  },
  {
    label: 'Therapist First Name',
    source: 'therapistFirstName',
    exportFn: (doc: any) => doc.therapistFirstName,
  },
  {
    label: 'Therapist Last Name',
    source: 'therapistLastName',
    exportFn: (doc: any) => doc.therapistLastName,
  },
  {
    label: 'Promo Code',
    source: 'promoCodeId',
    GridComponent: CopiableIdDataGridField,
    gridComponentProps: {
      // copyLink: true,
      targetNavigationResource: 'therapistPromoCodes',
      filter: ['promoCodeId'],
      // referenceField: "id",
      // formatFilter: (id: any) => ({ $oid: id }),
    },
    // exportFn: (doc: any) => doc.promoCode,
  },
  {
    label: 'Connected Patient Id',
    source: 'patientId',
    exportFn: (doc: any) => doc.patientId,
    GridComponent: CopiableIdDataGridField,
    gridComponentProps: {
      // copyLink: true,
      targetNavigationResource: 'users',
      // filter: ["patientId"],
    },
  },
  {
    label: 'Archived At',
    source: 'archivedAt',
    GridComponent: GenericDateFunctionField,
    exportFn: (doc: any) => doc.archivedAt?.toISOString(),
  },
  {
    label: 'Connected At',
    source: 'patientConnectedAt',
    GridComponent: GenericDateFunctionField,
    exportFn: (doc: any) => doc.patientConnectedAt?.toISOString(),
  },
  {
    label: 'Disconnected At',
    source: 'patientDisconnectedAt',
    GridComponent: GenericDateFunctionField,
    exportFn: (doc: any) => doc.patientDisconnectedAt?.toISOString(),
  },
  {
    label: 'Deleted At',
    source: 'deletedAt',
    GridComponent: GenericDateFunctionField,
    exportFn: (doc: any) => doc.deletedAt?.toISOString(),
    omit: true,
  },
];
